module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-minus-779c2da2.svg";